import React from 'react'

export type DiamondIconProps = {
  className?: string
  size?: number
  'aria-hidden'?: boolean
}

export function DiamondIcon({
  className = '',
  size = 10,
  'aria-hidden': ariaHidden = true,
}: DiamondIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      className={className}
      aria-hidden={ariaHidden}
    >
      <path d="M5 0L10 5L5 10L0 5L5 0Z" fill="#E60023" />
    </svg>
  )
}
